import './ProfileFantasy.scss';
import React, { useEffect, useState }  from 'react';
import { updateParticipanteNombre } from '../../firebase-service/firebaseService.js'
import { useAuth } from '../../context/authContext/index.js'
import cara from "../../assets/img/cara-default.png";
import { doSignOut } from '../../firebase-service/auth'
import { useNavigate } from 'react-router-dom'
import { toast } from 'sonner'

export function ProfileFantasy() {

    const { currentUser, actualParticipante, setCurrentParticipante } = useAuth()
    
    const navigate = useNavigate();

    const [openModal, setOpenModal] = useState(false);
    const [nombreInput, setNombreInput] = useState('');
    const [isSavingName, setIsSavingName] = useState(false);
    
    useEffect(() => {
    }, []);

    const handleLogOut = () => {
        doSignOut()
            .then(() => { navigate('/fantasy/login') })
            .catch(() => { toast.error('No se pudo cerrar sesión') })
    };

    const openNameEditor = () => {
        if (!actualParticipante) return;
        setNombreInput(actualParticipante.nombre || '');
        setOpenModal(true);
    };

    const closeNameEditor = () => {
        setOpenModal(false);
        setNombreInput('');
    };

    const handleSaveName = async () => {
        if (!actualParticipante) return;

        const nombreFormateado = nombreInput.trim();

        if (!nombreFormateado) {
            toast.error('El nombre no puede estar vacío');
            return;
        }

        setIsSavingName(true);

        try {
            const participanteId = actualParticipante.id || currentUser?.uid;
            await updateParticipanteNombre(participanteId, nombreFormateado);
            setCurrentParticipante((prev) => prev ? { ...prev, nombre: nombreFormateado } : prev);
            closeNameEditor();
            toast.success('Nombre actualizado');
        } catch (error) {
            console.error(error);
            toast.error('No se pudo actualizar el nombre');
        } finally {
            setIsSavingName(false);
        }
    };
    

    return (
        <main className="user-data-container">
            {actualParticipante && <div className='data-container'>
                <div className="user-image">
                    <img src={actualParticipante.foto ? actualParticipante.foto : cara} alt="Cara" className="player-face"/>
                </div>
                <div className="user-name user-name-button" onClick={openNameEditor}>
                    {actualParticipante.nombre}
                </div>
                <div className="user-points-title">
                    Puntos Totales
                </div>
                <div className="user-points">
                    {actualParticipante.puntosTotal}
                </div>


                <div className='button-log-out-container' onClick={()=> handleLogOut()}>
                    <div className='button-log-out'>
                        Cerrar sesión
                    </div>
                </div>
            </div>}

            {openModal && (
                <div className='modal-overlay' onClick={closeNameEditor}>
                    <div className='name-modal' onClick={(event) => event.stopPropagation()}>
                        <div className='close-modal' onClick={closeNameEditor}>X</div>
                        <h3>Editar nombre</h3>
                        <input
                            type='text'
                            value={nombreInput}
                            onChange={(event) => setNombreInput(event.target.value)}
                            maxLength={30}
                            placeholder='Tu nombre'
                        />
                        <div className='name-modal-actions'>
                            <button className='secondary-button' onClick={closeNameEditor}>Cancelar</button>
                            <button className='primary-button' onClick={handleSaveName} disabled={isSavingName}>
                                {isSavingName ? 'Guardando...' : 'Guardar'}
                            </button>
                        </div>
                    </div>
                </div>
            )}
           
        </main>
    );
}